import { defineComponent as T, ref as h, onMounted as $, watch as B, computed as v, openBlock as o, createElementBlock as l, normalizeClass as m, createElementVNode as s, withModifiers as f, createCommentVNode as r, toDisplayString as u, renderSlot as I, Fragment as V, renderList as A } from "vue";
import { n as D } from "./chunks/index.browser.Vf83cH3M.js";
import { _ as j } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/ConsultingCategoryItem.css';const F = ["open"], L = {
  key: 1,
  class: "consulting-category-checkbox"
}, N = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, q = { class: "consulting-category-header" }, E = {
  key: 0,
  class: "consulting-category-overline"
}, M = { class: "consulting-category-title" }, P = { class: "consulting-category-content-wrapper" }, _ = { class: "consulting-category-content" }, z = {
  key: 0,
  class: "consulting-category-teaser"
}, R = { class: "consulting-category-content-grid" }, G = {
  key: 0,
  class: "consulting-category-options"
}, H = ["name", "value", "checked", "onChange"], J = ["value", "checked", "onChange"], Q = ["href"], U = {
  key: 3,
  class: "consulting-category-option-label"
}, W = { class: "consulting-category-input" }, X = ["for"], Y = ["id", "name", "placeholder", "value"], Z = /* @__PURE__ */ T({
  __name: "ConsultingCategoryItem",
  props: {
    /**
     * Visual style variant.
     * - 'default': minimal borders, chevron left, no checkbox
     * - 'roundedBorders': full borders, checkbox left, chevron right
     * @default 'default'
     */
    variant: {
      type: String,
      default: "default"
    },
    /**
     * Unique key for this category (e.g., 'prerequisites', 'terms_and_options').
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Main title displayed in the accordion header.
     */
    title: {
      type: String,
      required: !0
    },
    /**
     * Optional overline text above the title (smaller, muted).
     */
    overline: {
      type: String
    },
    /**
     * Predefined options within this category.
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * How to render options: 'checkbox' (multiple) or 'radio' (single).
     * @default 'checkbox'
     */
    optionType: {
      type: String,
      default: "checkbox"
    },
    /**
     * Currently selected option keys.
     */
    selectedOptions: {
      type: Array,
      default: () => []
    },
    /**
     * Label for the freeform text input.
     *
     * @default 'Ihre Frage oder Anmerkung'
     */
    inputLabel: {
      type: String,
      default: "Ihre Frage oder Anmerkung"
    },
    /**
     * Placeholder for the freeform text input.
     *
     * @default 'Optional: Beschreiben Sie Ihr Anliegen...'
     */
    inputPlaceholder: {
      type: String,
      default: "Optional: Beschreiben Sie Ihr Anliegen..."
    },
    /**
     * Whether this category is currently selected/open.
     * Auto-checks when expanded.
     */
    modelValue: {
      type: Boolean,
      default: !1
    },
    /**
     * The freeform text value for this category.
     */
    freeformText: {
      type: String,
      default: ""
    },
    /**
     * Delay in ms before expanding the category after activation.
     * 0 = no delay (immediate expansion)
     * @default 0
     */
    expansionDelay: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:modelValue", "update:freeformText", "update:selectedOptions"],
  setup(e, { emit: k }) {
    const i = e, d = k, y = h(`${i.name}-input`);
    $(() => {
      y.value = `${i.name}-${D(6)}`;
    });
    const p = h(i.modelValue);
    let g = null;
    B(() => i.modelValue, (a) => {
      g && (clearTimeout(g), g = null), a && i.expansionDelay > 0 ? g = setTimeout(() => {
        p.value = !0;
      }, i.expansionDelay) : p.value = a;
    });
    const c = v(() => p.value), x = v(() => i.freeformText), w = () => {
      d("update:modelValue", !i.modelValue);
    }, C = (a) => {
      const t = a.target;
      d("update:freeformText", t.value);
    }, b = (a) => {
      const t = [...i.selectedOptions], n = t.indexOf(a);
      n === -1 ? t.push(a) : t.splice(n, 1), d("update:selectedOptions", t);
    }, O = (a) => {
      d("update:selectedOptions", [a]);
    };
    return (a, t) => (o(), l("details", {
      open: c.value,
      class: m(["consulting-category", [
        `consulting-category--${e.variant}`,
        { "consulting-category-checked": c.value }
      ]])
    }, [
      s("summary", {
        onClick: f(w, ["prevent"]),
        class: "consulting-category-summary"
      }, [
        e.variant === "default" ? (o(), l("span", {
          key: 0,
          class: m(["consulting-category-chevron", { "consulting-category-chevron-open": c.value }])
        }, [...t[1] || (t[1] = [
          s("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            s("polyline", { points: "9 6 15 12 9 18" })
          ], -1)
        ])], 2)) : r("", !0),
        e.variant === "roundedBorders" ? (o(), l("span", L, [
          c.value ? (o(), l("svg", N, [...t[2] || (t[2] = [
            s("polyline", { points: "20 6 9 17 4 12" }, null, -1)
          ])])) : r("", !0)
        ])) : r("", !0),
        s("div", q, [
          e.overline ? (o(), l("span", E, u(e.overline), 1)) : r("", !0),
          s("span", M, u(e.title), 1)
        ]),
        e.variant === "roundedBorders" ? (o(), l("span", {
          key: 2,
          class: m(["consulting-category-chevron", { "consulting-category-chevron-open": c.value }])
        }, [...t[3] || (t[3] = [
          s("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            s("polyline", { points: "6 9 12 15 18 9" })
          ], -1)
        ])], 2)) : r("", !0)
      ]),
      s("div", P, [
        s("div", _, [
          a.$slots.default ? (o(), l("div", z, [
            I(a.$slots, "default", {}, void 0, !0)
          ])) : r("", !0),
          s("div", R, [
            e.options && e.options.length > 0 ? (o(), l("div", G, [
              (o(!0), l(V, null, A(e.options, (n) => (o(), l("label", {
                key: n.key,
                class: "consulting-category-option"
              }, [
                e.optionType === "radio" ? (o(), l("input", {
                  key: 0,
                  type: "radio",
                  name: `${e.name}-options`,
                  value: n.key,
                  checked: e.selectedOptions.length === 1 && e.selectedOptions[0] === n.key,
                  onChange: (S) => O(n.key),
                  class: "consulting-category-option-input"
                }, null, 40, H)) : (o(), l("input", {
                  key: 1,
                  type: "checkbox",
                  value: n.key,
                  checked: e.selectedOptions.includes(n.key),
                  onChange: (S) => b(n.key),
                  class: "consulting-category-option-input"
                }, null, 40, J)),
                n.url ? (o(), l("a", {
                  key: 2,
                  href: n.url,
                  target: "_blank",
                  class: "consulting-category-option-label consulting-category-option-link",
                  onClick: t[0] || (t[0] = f(() => {
                  }, ["stop"]))
                }, u(n.label), 9, Q)) : (o(), l("span", U, u(n.label), 1))
              ]))), 128))
            ])) : r("", !0),
            s("div", W, [
              s("label", {
                for: y.value,
                class: "consulting-category-input-label"
              }, u(e.inputLabel), 9, X),
              s("textarea", {
                id: y.value,
                name: `${e.name}-freeform`,
                placeholder: e.inputPlaceholder,
                value: x.value,
                onInput: C,
                class: "consulting-category-textarea",
                rows: "3"
              }, null, 40, Y)
            ])
          ])
        ])
      ])
    ], 10, F));
  }
}), ne = /* @__PURE__ */ j(Z, [["__scopeId", "data-v-7aecd24d"]]);
export {
  ne as default
};
